{
  "decrease": "הקטן {fieldLabel}",
  "increase": "הגדל {fieldLabel}",
  "numberField": "שדה מספר"
}
